import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { LoyaltyConfig } from "@/components/contest-form/LoyaltyConfig";

export function CodesSection({ form, set, contestId }) {
  return (
    <>
      <div className="flex items-center justify-between rounded-lg bg-secondary/40 p-4">
        <div>
          <Label>Codici univoci (QR / manuale)</Label>
          <p className="text-xs text-muted-foreground mt-0.5">Codici generati in lotti per i punti vendita</p>
        </div>
        <Switch data-testid="unique-code-switch" checked={form.unique_code_enabled} onCheckedChange={(v) => set("unique_code_enabled", v)} />
      </div>
      <div className="rounded-lg bg-secondary/40 p-4 space-y-3">
        <div className="flex items-center justify-between">
          <div>
            <Label>Carta fedeltà</Label>
            <p className="text-xs text-muted-foreground mt-0.5">Accetta codici carta fedeltà (1 gioco/giorno)</p>
          </div>
          <Switch data-testid="loyalty-switch" checked={form.loyalty_card_enabled} onCheckedChange={(v) => set("loyalty_card_enabled", v)} />
        </div>
        {form.loyalty_card_enabled && <LoyaltyConfig form={form} set={set} contestId={contestId} />}
      </div>
      <div className="rounded-lg bg-secondary/40 p-4 space-y-2">
        <div className="flex items-center justify-between gap-3">
          <div>
            <Label>Scadenza ricevute</Label>
            <p className="text-xs text-muted-foreground mt-0.5">Giorni entro cui ritirare il premio (vuoto = nessuna scadenza)</p>
          </div>
          <Input data-testid="expiry-days-input" type="number" min={1} value={form.receipt_expiry_days} onChange={(e) => set("receipt_expiry_days", e.target.value)} placeholder="es. 30" className="w-24" />
        </div>
        {form.receipt_expiry_days !== "" && (
          <div className="flex items-center justify-between gap-3 pt-2 border-t border-border/50">
            <div>
              <Label>Promemoria email</Label>
              <p className="text-xs text-muted-foreground mt-0.5">Giorni prima della scadenza (invio automatico ogni giorno alle 9:00)</p>
            </div>
            <Input data-testid="reminder-days-input" type="number" min={1} value={form.reminder_days_before} onChange={(e) => set("reminder_days_before", e.target.value)} className="w-24" />
          </div>
        )}
      </div>
    </>
  );
}
